import { loadPreferences, myPreferences } from '@/appLogic/view/preferences';
import { TableType } from '@/coreDomainsModule/table';
import { INetworkResult } from '@/coreDomainsModule/networkResult';

/**
 * 保持した列幅を取得する
 */
export class GetColumnWidthsUseCase {
  /**
   * 列幅の配列を取得する
   * @param tableType - テーブルの種類
   * @returns key: 列名, value: 列幅
   */
  public async Execute(tableType: TableType): Promise<INetworkResult<{ [key: string]: number }, Error>> {
    try {
      await loadPreferences();
      if (!myPreferences || !Object.keys(myPreferences).includes(tableType) || !myPreferences[tableType].columnWidths) {
        return {
          status: {
            type: 'error',
            error: Error('取得に失敗しました'),
          },
        };
      }
      return {
        status: {
          type: 'success',
          data: myPreferences[tableType].columnWidths,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
